import { BsInstagram } from "react-icons/bs";
import styled from "styled-components";

export const NavLink = styled.a`
  color: white;
  text-decoration: none;
  font-size: 1.5rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  margin-top: 1rem;
  cursor: pointer;
  transition: opacity 0.2s ease-in-out;

  &:hover {
    opacity: 75%;
  }

  @media (max-width: 48rem) {
    display: none;
  }
`;
